export const QUERY_SIGNALS_ACTIONS_KEYS = {
  getNextQueries: 'getNextQueries',
  getRelatedTags: 'getRelatedTags',
  getNextQueriesResults: 'getNextQueriesResults'
} as const;

export const QUERY_SIGNALS_GETTERS_KEYS = {
  nextQueries: 'nextQueries',
  nextQueriesFilters: 'nextQueriesFilters',
  nextQueriesWithResults: 'nextQueriesWithResults',
  selectedRelatedTags: 'selectedRelatedTags'
} as const;

export const QUERY_SIGNALS_MUTATIONS_KEYS = {
  updateNextQuery: 'updateNextQuery',
  toggleRelatedTag: 'toggleRelatedTag',
  resetNextQueryResults: 'resetNextQueryResults',
  clearRelatedTags: 'clearRelatedTags',
  deselectRelatedTags: 'deselectRelatedTags',
  clearNextQueriesState: 'clearNextQueriesState',
  setNextQueriesState: 'setNextQueriesState',
  setRelatedTags: 'setRelatedTags',
  setLastNextQueryLoaded: 'setLastNextQueryLoaded'
} as const;
